<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
// 定义全局粘贴处理函数
  const handleGlobalPaste = (event) => {
    const target = event.target;
    
    // 判断是否是输入框元素
    // 兼容原生 input 和 Element UI/Plus 的 .el-input__inner
    const isInput = 
      target.tagName === 'INPUT' || 
      target.tagName === 'TEXTAREA' || 
      target.classList.contains('el-input__inner') ||
      target.classList.contains('el-textarea__inner');

    if (isInput) {
      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      const pastedText = clipboardData.getData('text');

      // 检查是否包含英文双引号
      if (pastedText.includes('"')) {
        // 阻止默认粘贴行为
          event.preventDefault();
          const filteredText = pastedText.replace(/"/g, '');
          
          // 插入逻辑...
          const start = target.selectionStart;
          const end = target.selectionEnd;
          const val = target.value;
          target.value = val.substring(0, start) + filteredText + val.substring(end);
          target.setSelectionRange(start + filteredText.length, start + filteredText.length);
          
          // 触发 input 事件
          target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  };
  export default{
    data () {
      return {
        checkInterval:null,
        sessionTimeout: 240*60*1000 // 240分钟
      }
    },
    //添加事件监听（点击、键盘输入）实时更新最后一次活动时间戳至本地存储
    mounted () {
      // 添加事件监听，第三个参数 true 表示在捕获阶段执行
      // 这样可以确保在事件到达具体组件之前就被拦截
      document.addEventListener('paste', handleGlobalPaste, true);

      window.addEventListener('click',this.updateLastActiveTime)
      window.addEventListener('keypress',this.updateLastActiveTime)
      this.checkInterval = setInterval(() => {
        const lastActiveTime = localStorage.getItem('lastActiveTime');
        if (Date.now() - lastActiveTime > this.sessionTimeout) {
          this.handleLogout()
        }
      }, 300 * 1000); // 300秒检查一次
    },
    methods: {
      updateLastActiveTime(){
         localStorage.setItem('lastActiveTime',Date.now())
      },
      handleLogout(){
        localStorage.removeItem('lastActiveTime')
        let routeUrl = this.$router.resolve({
            path: '/login',
            query: {},
        });
        window.open(routeUrl.href, '_self')
        //this.$message.error('登录已超时，请重新登录');
      }
    },
    beforeDestroy () {
      window.removeEventListener('click',this.updateLastActiveTime)
      window.removeEventListener('keypress',this.updateLastActiveTime)
      clearInterval(this.checkInterval)
 
      // 组件卸载时移除监听，防止内存泄漏
      document.removeEventListener('paste', handleGlobalPaste, true);
    }
  }
</script>
<style>
html,body{
  width: 100%;
  height: 100%;
}
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul{
  outline: 0;
  list-style: none;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height:100%;
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  left:0
}
 

  /** iPad **/
  @media only screen and (min-width: 768px) and (max-width: 1024px) {}
  /** iPhone **/
  @media only screen and (min-width: 320px) and (max-width: 767px) {}
</style>
